export function chooseReachoutMessageToDisplay(reachoutMessages, dismissedMessageIds) {
    if (!reachoutMessages) {
      return null;
    }
    if (!dismissedMessageIds) {
      return reachoutMessages[0];
    }

    return reachoutMessages.find(m => !dismissedMessageIds.includes(m.id));
}

/**
 * Append the new id to the current array of ids, filter the array to include only ids
 * corresponding to current messages, and save (persist and update store).
 */
export function persistNewDismissedReachoutMessageId(id, currentDismissedIds, reachoutMessages, saveIds) {
    let dismissedIds = [...currentDismissedIds, id];

    // Clean up the dismissed ids by removing all ids that don't correspond to an existing message.
    const currentIds = reachoutMessages.reduce((acc, m) => { acc.push(m.id); return acc; }, []);
    dismissedIds = dismissedIds.filter(h => currentIds.includes(h));

    saveIds(dismissedIds);
  };



// WEBPACK FOOTER //
// ./src/portfolio-shared/util/reachoutUtils.js